import React, { ReactNode, useState } from 'react';
import { useQueryClient } from 'react-query';
import { Button, IconButton } from '@fiverr-private/button';
import { PlusIcon } from '@fiverr-private/visuals';
import { BriefCreationDrawerWrapper } from '@fiverr-private/dm_brief_creation';
import { PAGE_NAME } from '../../../../configuration/constants';
import { AppI18n, appTranslate } from '../../i18n';
import { useInitialProps } from '../../context';
import { BRIEFS_PAGINATED_LIST_QUERY_KEY } from '../shared/const';
import { reportButtonClick } from '../shared/bqEvents';

interface CreateBriefButtonProps {
  title?: ReactNode;
  isIconButton?: boolean;
}

export const CreateBriefButton = ({ title, isIconButton = false }: CreateBriefButtonProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const queryClient = useQueryClient();
  const { currency, rollouts } = useInitialProps();
  const createBriefCopy = 'lobby.create_new_brief';
  const enableScreeningQuestions = Boolean(rollouts?.inLynxesScreeningQuestionsBriefsLobby);

  const onCreateClick = () => {
    setIsDrawerOpen(true);
    reportButtonClick('create_brief');
  };

  const onBriefSuccess = () => {
    queryClient.invalidateQueries({ queryKey: BRIEFS_PAGINATED_LIST_QUERY_KEY });
  };
  return (
    <>
      {isIconButton ? (
        <IconButton intent="primary" aria-label={appTranslate(createBriefCopy) as string} onClick={onCreateClick}>
          <PlusIcon />
        </IconButton>
      ) : (
        <Button onClick={onCreateClick}>{title || <AppI18n k={createBriefCopy} />}</Button>
      )}
      <BriefCreationDrawerWrapper
        onSuccess={onBriefSuccess}
        isOpen={isDrawerOpen}
        setIsOpen={setIsDrawerOpen}
        source={PAGE_NAME}
        currency={currency}
        rollouts={rollouts}
        enableEnhancedUx
        enableScreeningQuestions={enableScreeningQuestions}
      />
    </>
  );
};
